/* eslint-disable */
import { useState } from "react";
import { Star } from "lucide-react";
import "./StarRating.css";

export default function StarRating({
  value = 0,
  onChange,
  size = 24,
  readOnly = false,
  showCount = false,
  count = 0,
}) {
  const [hover, setHover] = useState(0);
  const stars = [1, 2, 3, 4, 5];
  const active = hover || value;

  const handleKey = (e, n) => {
    if (readOnly) return;
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onChange && onChange(n);
    }
    if (e.key === "ArrowLeft") onChange && onChange(Math.max(1, value - 1));
    if (e.key === "ArrowRight") onChange && onChange(Math.min(5, value + 1));
  };

  return (
    <div
      className={`vsr-stars ${readOnly ? "readonly" : "interactive"}`}
      role={readOnly ? "img" : "radiogroup"}
      aria-label={
        readOnly
          ? `${value} out of 5 stars${count ? ` from ${count} review${count === 1 ? "" : "s"}` : ""}`
          : "Rate this service"
      }
    >
      {stars.map((n) => {
        const filled = n <= active;
        return readOnly ? (
          <span
            key={n}
            className={`vsr-star ${filled ? "filled" : ""}`}
          >
            <Star
              size={size}
              strokeWidth={1.5}
              fill={filled ? "#F59E0B" : "none"}
              color={filled ? "#F59E0B" : "#cbd5e1"}
            />
          </span>
        ) : (
          <button
            type="button"
            key={n}
            className={`vsr-star ${filled ? "filled" : ""}`}
            onClick={() => onChange && onChange(n)}
            onMouseEnter={() => setHover(n)}
            onMouseLeave={() => setHover(0)}
            onKeyDown={(e) => handleKey(e, n)}
            aria-label={`${n} star${n === 1 ? "" : "s"}`}
            aria-pressed={n === value}
          >
            <Star
              size={size}
              strokeWidth={1.5}
              fill={filled ? "#F59E0B" : "none"}
              color={filled ? "#F59E0B" : "#cbd5e1"}
            />
          </button>
        );
      })}
      {showCount && (
        <span className="vsr-count">
          {value.toFixed(1)}
          {count > 0 && (
            <span className="vsr-count-meta">
              {" "}({count} review{count === 1 ? "" : "s"})
            </span>
          )}
        </span>
      )}
    </div>
  );
}
